import React from 'react';
import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Search, Page } from '@syncfusion/ej2-react-grids';
import { MdContentCopy } from 'react-icons/md';

import { Header } from '../components';
import { BACKEND_URL, USD_PRODUCT_ID } from '../data/constants';
import { toast } from 'react-toastify';


class LinksUSD extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        items: [],
        DataisLoaded: false
    };
  }

  componentDidMount() {
    fetch(`${BACKEND_URL}/stripe/${USD_PRODUCT_ID}/links`, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })
    .then((res) => res.json())
    .then((json) => {
        this.setState({
            items: json,
            DataisLoaded: true
        });
    })
  }

  render() {
    const { DataisLoaded, items } = this.state;
    if (!DataisLoaded) return (
      <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white">
        <h1 className='text-center'> Trayendo links.... </h1> 
      </div> 
    );

    return (
      <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
        <Header category="Page" title="Links (USD)" />

        <GridComponent
          dataSource={items}
          width="auto"
          allowPaging
          allowSorting
          pageSettings={{ pageCount: 5 }}
          editSettings={{ allowDeleting: false, allowEditing: false, selection: false }}
          toolbar= {['Search']}
        >
          <ColumnsDirective>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            {linksGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
          </ColumnsDirective>
          <Inject services={[Search, Page]} />

        </GridComponent>
      </div>
    );
  }
}

const gridCopyButton = (props) => (
  <div className="flex items-center gap-2">
    <p>{props.url}</p>
    <button
      className="rounded-full w-10 h-10"
      onClick={() => {
        navigator.clipboard.writeText(props.url)
        toast(" Link copiado! ")
      }
      }
    >
      <MdContentCopy />
    </button>
  </div>
);

const linksGrid = [
  { field: 'price',
    headerText: 'Monto',
    width: '100',
    textAlign: 'Center',
  },
  { field: 'currency',
    headerText: 'Moneda',
    width: '120',
    textAlign: 'Center',
  },
  { field: 'url',
    headerText: 'Link',
    width: '320',
    textAlign: 'Center',
    template: gridCopyButton,
  },
];

export default LinksUSD;